module.exports = __webpack_public_path__ + "static/media/30-6.b9c4ca41.mp3";